import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
    MatIconModule,
    MatCardModule,
  ],
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit {
  loading = false;
  successMessage = '';
  errorMessage = '';
  particles: { left: string; top: string; size: string; delay: string; }[] = [];
  private router = inject(Router);

  goToLogin() {
    this.router.navigate(['/login']);
  }

  ngOnInit(): void {
    this.generateParticles();

  }


  generateParticles(): void {
    for (let i = 0; i < 15; i++) {
      this.particles.push({
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        size: `${10 + Math.random() * 20}px`,
        delay: `${Math.random() * 15}s`
      });
    }
  }


}
